module.exports = __webpack_public_path__ + "88e0d498fe7caec5bea0840bb35d49f5.jpg";